import React from "react";
import { useAuth } from "@/contexts/AuthContext";
import { useQuery } from "@tanstack/react-query";
import { Navigate } from "react-router-dom";
import { supabase } from "@/integrations/supabase/client";
import { Button } from "@/components/ui/button";
import {
  Card,
  CardContent,
  CardDescription,
  CardHeader,
  CardTitle,
} from "@/components/ui/card";
import { Loader2 } from "lucide-react";

export default function ConnectMeta() {
  const { user, connectMeta } = useAuth();

  // If already connected, skip to next step
  const { data: hasToken, isLoading } = useQuery({
    queryKey: ["setup-meta-token", user?.id],
    queryFn: async () => {
      const { data } = await supabase
        .from("meta_oauth_tokens")
        .select("id")
        .eq("user_id", user!.id)
        .maybeSingle();
      return !!data;
    },
    enabled: !!user?.id,
  });

  if (isLoading) {
    return (
      <div className="flex justify-center py-12">
        <Loader2 className="h-8 w-8 animate-spin text-muted-foreground" />
      </div>
    );
  }

  if (hasToken) {
    return <Navigate to="/setup/select-accounts" replace />;
  }

  return (
    <Card>
      <CardHeader className="text-center">
        <CardTitle className="text-xl">
          Connect your Facebook Ad Account
        </CardTitle>
        <CardDescription>
          To get started, connect your Meta account so we can import your ad
          accounts, pages, and creative assets.
        </CardDescription>
      </CardHeader>
      <CardContent className="flex flex-col items-center gap-4">
        <Button
          size="lg"
          className="w-full max-w-xs bg-[hsl(221,44%,41%)] hover:bg-[hsl(221,44%,35%)] text-white"
          onClick={connectMeta}
        >
          Connect with Facebook
        </Button>
        <p className="text-xs text-muted-foreground text-center max-w-sm">
          We'll request permission to manage your ad accounts, read campaign
          data, and access your Facebook Pages and Instagram accounts.
        </p>
      </CardContent>
    </Card>
  );
}
